import { endOfMonth, format } from 'date-fns';

export const getFromDate = (from: Date) => `${format(from, 'yyyy-MM')}-01T00:00:01.000`;
export const getToDate = (to: Date) => `${format(to, 'yyyy-MM')}-${endOfMonth(to).getDate()}T23:59:59.000`;
